import { userInfoSync } from 'hub-http/userInfo';
import Raven from 'raven-js';
import enviro from 'enviro';
import { SCOPES } from '../constants/scopes';
export const useIsReconnectable = args => {
  const skip = (args === null || args === void 0 ? void 0 : args.skip) === true;
  if (skip) return true;
  try {
    const userInfo = userInfoSync();
    const {
      scopes
    } = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user) || {
      scopes: []
    };
    return scopes.includes(SCOPES.INTEGRATIONS_MANAGEMENT_WRITE);
  } catch (err) {
    if (enviro.isQa()) {
      console.error(err);
    }
    Raven.captureException(err, {
      extra: {
        message: 'Error getting user info from `userInfoSync`'
      }
    });
    return false;
  }
};